import React from 'react';
import styled from 'styled-components';
import { Box } from './Box';

function LogoSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 1169.6 160.2"
      style={{ fill: 'var(--dark-brown)' }}
    >
      <g data-name="Layer 1">
        <path d="M138.4 7.4v138.4H82.7V118l-13 33.6-14-31.8v26H0V7.5h52l3.6 9.3 14 35 13.1-32.5 4.7-11.8h51ZM293.7 145.8h-62l-9.9-23.3H211l-9.4 23.3h-61.2L199 7.4H237l56.6 138.4Zm-70.2-56c0-4.2-3-7.4-7.5-7.4s-7.4 3.2-7.4 7.4 3 7.5 7.4 7.5 7.5-3.2 7.5-7.5ZM434.4 7.4v138.4h-55.7V118l-13 33.6-14-31.8v26H296V7.5h52l3.7 9.3 14 35 13-32.5 4.8-11.8h50.9ZM589.7 145.8h-62l-9.9-23.3H507l-9.4 23.3h-61.2L495 7.4H533l56.6 138.4Zm-70.2-56c0-4.2-3-7.4-7.5-7.4s-7.4 3.2-7.4 7.4 3 7.5 7.4 7.5 7.5-3.2 7.5-7.5ZM660.6 48.3c0 8.5 31.6 13.2 31.6 50.5s-35.8 49.6-55 49.6-37.9-5.6-49.8-16.3l18.6-26.2h1.5c1 3.7 4 6.1 7.5 6.1s6.5-2.6 6.5-6.9c0-7.1-31.6-14.3-31.6-49 0-30.3 22.3-51.2 55.6-51.2A71 71 0 0 1 693.6 22l-18.3 26.3h-1.1c-.8-2.7-3.5-6-7.7-6-3.7 0-5.9 2.8-5.9 6ZM910.2 76.6v69.2l-29.2-11-2 .7a68 68 0 0 1-40.1 12.8c-41.3 0-70.5-33.7-70.5-71.7S798.9 4.8 840 4.8A72.1 72.1 0 0 1 904 45.4l-56.1 27.5c-1.6-3-4-4.9-7.8-4.9a8.6 8.6 0 1 0 .6 17.2h6.8v-8.6h62.7ZM1043.8 7.4v80.1c0 36.6-25 60.8-64 60.8s-64-24.2-64-60.8V7.4H975V90c0 3.8 1 6.3 4.8 6.3s4.8-2.5 4.8-6.3V7.4h59.2ZM1169.6 7.4v152.8h-1l-60.8-46v31.6h-55.6V0h1.2l60.6 45.8V7.4h55.6Z" />
      </g>
    </svg>
  );
}

export function Logo() {
  return (
    <LogoLink
      as="a"
      href="#"
      display="flex"
      aria-labelledby="Mamas Gun logo"
      style={{
        width: '150px',
        height: '20px'
      }}
    >
      <LogoSvg />
    </LogoLink>
  );
}

const LogoLink = styled(Box)`
  cursor: pointer;
  user-select: none;
  &.focus-visible {
    outline: 5px solid blue;
  }
`;

const LabelWrapper = styled.span`
  height: inherit;
  &:last-child {
    margin-left: 0.25rem;
  }
`;
